var map = {
	"./0_stars.svg": "Aedy",
	"./1.5_stars.svg": "YSGP",
	"./1_stars.svg": "5do4",
	"./2.5_stars.svg": "7jrH",
	"./2_stars.svg": "nTYK",
	"./3.5_stars.svg": "nMtB",
	"./3_stars.svg": "9IGc",
	"./4.5_stars.svg": "GCIW",
	"./4_stars.svg": "KHy9",
	"./5_stars.svg": "7Sp5",
	"./DWM.svg": "OG4s",
	"./IP_AwardsBadge_Desktop.svg": "jhoD",
	"./IP_AwardsBadge_Tablet.svg": "hkGR",
	"./Logo_Raisin_homepage.svg": "9pW0",
	"./Logo_Raisinbank_homepage.svg": "vQG4",
	"./Logo_WeltSparenBusiness_homepage.svg": "XSvF",
	"./Logo_WeltSparen_homepage.svg": "eG0R",
	"./Success.png": "nowA",
	"./app-icon-80.svg": "7CVM",
	"./app_on_mobile.svg": "3lxc",
	"./appstore_badge_de-AT.svg": "eSp+",
	"./appstore_badge_de.svg": "Brqt",
	"./appstore_badge_en-GB.svg": "+1u7",
	"./appstore_badge_en-IE.svg": "WTl/",
	"./appstore_badge_en-US.svg": "vXui",
	"./appstore_badge_es.svg": "rLQt",
	"./appstore_badge_fi-FI.svg": "UBaW",
	"./appstore_badge_fr.svg": "7P+Q",
	"./appstore_badge_nl.svg": "bWZs",
	"./appstore_badge_pl-PL.svg": "tSYo",
	"./arrow_smartphone.png": "Pi0K",
	"./aut-tuv-raisin.svg": "L20n",
	"./background.svg": "P6Pc",
	"./badge_w_de.svg": "CP5Q",
	"./banking-logo-company.svg": "xGY9",
	"./banking-logo-raisin-2x.png": "s1Sz",
	"./bnp_paribas_gs.png": "Tlq+",
	"./climate-action.svg": "t+dc",
	"./close_24.svg": "oqhL",
	"./comodo_secure_seal.png": "Ts6W",
	"./copy-to-clipboard_24.svg": "eTVu",
	"./cost_comparison_sm_xs.svg": "5oBY",
	"./cost_comparison_xl_lg.svg": "4mB3",
	"./credorax-logo.png": "7e+e",
	"./dabbnpparibas_logo.svg": "IRvS",
	"./data_transfer_pp_xl.svg": "w5vX",
	"./data_transfer_pp_xs.svg": "hjo6",
	"./deu-tuv-raisin.svg": "i1sW",
	"./devices_desktop_justETF.png": "1Sii",
	"./empty_dashboard.png": "2ghK",
	"./envelope_24.svg": "yYNN",
	"./experts-adam-nash.png": "IyFd",
	"./experts-al-breach.png": "E8uk",
	"./experts-martin-weber.png": "XUh5",
	"./facebook.svg": "O/++",
	"./favicon-raisin-180x180.png": "l9s+",
	"./favicon-raisin-192x192.png": "4jmi",
	"./favicon-raisin-270x270.png": "UaBr",
	"./favicon-raisin-32x32.png": "RXKi",
	"./favicon_raisin_arrow_180x180.png": "m2NN",
	"./favicon_raisin_arrow_192x192.png": "eKb/",
	"./favicon_raisin_arrow_270x270.png": "BiaX",
	"./favicon_raisin_arrow_32x32.png": "Yqli",
	"./festgeld_promotional_banner.png": "q0Nu",
	"./gift_24.svg": "SqJ8",
	"./googleplay_badge_de-AT.svg": "F7xZ",
	"./googleplay_badge_de.svg": "2yNY",
	"./googleplay_badge_en-GB.svg": "Ui82",
	"./googleplay_badge_en-IE.svg": "exkm",
	"./googleplay_badge_en-US.svg": "XE2a",
	"./googleplay_badge_es.svg": "c/7o",
	"./googleplay_badge_fi-FI.svg": "nNfi",
	"./googleplay_badge_fr.svg": "D7Cr",
	"./googleplay_badge_nl.svg": "pgd7",
	"./googleplay_badge_pl-PL.svg": "M4UE",
	"./icon-user-lock.svg": "kUWz",
	"./icon_1_laptop.svg": "ru/j",
	"./icon_2_calendar.svg": "jDqY",
	"./icon_3_checkmark.svg": "3Bs4",
	"./icon_id_docu_small.png": "IJ7f",
	"./id_card.png": "xpbz",
	"./id_now_de-AT.png": "lJxa",
	"./id_now_de.png": "JCxm",
	"./id_now_en-GB.png": "iTI9",
	"./id_now_en-IE.png": "WucB",
	"./id_now_en-US.png": "Fvge",
	"./id_now_es.png": "6Iys",
	"./id_now_fr.png": "DaU5",
	"./id_now_nl.png": "EtXJ",
	"./image-migration-modal-desktop.png": "sShF",
	"./image-migration-modal-mobile.png": "pisX",
	"./img-DWM-lp-mockup.svg": "LY6F",
	"./img-robo-advisor-desktop.png": "OTAl",
	"./img-robo-advisor-tablet-mobile.png": "5OtV",
	"./img_config_costs_desktop_tablet.svg": "1w1n",
	"./img_config_costs_mobile.svg": "iYy7",
	"./img_configurator_desktop_tablet.png": "kJ5w",
	"./img_configurator_mobile.png": "FdOJ",
	"./img_rebalancing_desktop_tablet.svg": "HAnF",
	"./img_rebalancing_mobile.svg": "epm1",
	"./instagram.svg": "siQV",
	"./ipdm-rating.svg": "+02G",
	"./izola-logo.png": "aBIh",
	"./justETF_Leitfaden_preview.png": "LCaD",
	"./justETF_Leitfaden_preview_mobile.png": "BImG",
	"./justETF_PLP_xl_costs_bar_graph.svg": "v8VJ",
	"./justETF_PLP_xs_costs_bar_graph.svg": "Zbsz",
	"./justETF_logo.png": "6eVe",
	"./justETF_logo.svg": "UZVX",
	"./justETF_praemie_xl.svg": "JFjV",
	"./justETF_praemie_xs.svg": "iPiZ",
	"./just_etf_experts.png": "jBR6",
	"./justetf_hero.jpg": "c8Es",
	"./linkedin.svg": "e1w+",
	"./logo-header-raisin-bank.svg": "BOHP",
	"./map.svg": "n2B5",
	"./menu_24.svg": "bXvf",
	"./mobile_phone.png": "EnxF",
	"./newsletter_subscription_reminder.png": "ffi/",
	"./obs_login.png": "5Tvh",
	"./overdraft.svg": "fHk0",
	"./phone_24.svg": "+pcF",
	"./plp_gradient_bg.svg": "Fez0",
	"./postident_id.png": "VSSB",
	"./preview_history_chart_blur.png": "JZWr",
	"./print_coupon.png": "AIaG",
	"./privateEquity_promotional_banner.png": "8G1a",
	"./progress-separator-sm.svg": "oa70",
	"./progress-separator-xl-md.svg": "PYs5",
	"./progress-separator-xs.svg": "9aAi",
	"./raisin-arrow-blue.svg": "OMNI",
	"./raisin-logo.svg": "ZLP9",
	"./raisin_invest_logo.svg": "DAR0",
	"./raisin_pension_logo.svg": "JE3f",
	"./rebalancing-WI70-md.svg": "Svi/",
	"./rebalancing-WI70-sm-xs.svg": "PHbv",
	"./rebalancing-WI70-xl-lg.svg": "Lt9j",
	"./rebalancing-desktop.svg": "OjDo",
	"./rebalancing-mobile.svg": "2CYd",
	"./refer-a-friend-banner-uk.jpg": "LQdE",
	"./refer-a-friend_teaser-small.png": "Dt1l",
	"./refer_a_friend.svg": "Rp5Y",
	"./refer_a_friend_50_euro.svg": "/FIR",
	"./refer_a_friend_50_euro_sign_before_value.svg": "JPEm",
	"./refer_a_friend_aut_may_campaign_2025.svg": "paXz",
	"./refer_a_friend_deu_may_campaign_2025.svg": "iwTX",
	"./refer_a_friend_es.svg": "Edzq",
	"./refer_a_friend_esp.svg": "aX0j",
	"./refer_a_friend_esp_may_campaign_2025.svg": "5U5l",
	"./refer_a_friend_fra_may_campaign_2025.svg": "UEDA",
	"./refer_a_friend_gbr.jpg": "+vqb",
	"./refer_a_friend_gbr.svg": "Pi+o",
	"./refer_a_friend_irl_may_campaign_2025.svg": "h4St",
	"./refer_a_friend_ned_may_campaign_2025.svg": "l/ea",
	"./refer_a_friend_pol.svg": "htJs",
	"./refer_a_friend_pol_may_campaign_2025.svg": "IQz1",
	"./refer_a_friend_uk_campaign_2025.svg": "h+1g",
	"./refer_a_friend_winter_campaign.svg": "oLpS",
	"./refer_a_friend_winter_campaign_esp.svg": "bvrE",
	"./refer_a_friend_winter_campaign_gbr.svg": "nA50",
	"./refer_a_friend_winter_campaign_nl.svg": "YONe",
	"./ringgraphic_notification.png": "glTH",
	"./ringgraphic_notification_wo_product.png": "AERa",
	"./rs-cash-euro.svg": "vCs8",
	"./rs-configurator.svg": "I3YC",
	"./rs-piggybank.svg": "Bkzu",
	"./rs-robo-advisor.svg": "XVsE",
	"./rs-select.svg": "ZhjI",
	"./rs-user-lock.svg": "B6cq",
	"./savings_swoosh_xl_lg_md.svg": "OaOs",
	"./sello_confianza-online.svg": "tumD",
	"./signaliduna.png": "Vpbo",
	"./thuiswinkel-logo.svg": "Z4hu",
	"./trustPilot-icon.svg": "LiXX",
	"./trustpilot_logo_color.png": "CMCM",
	"./tuv-logo.png": "qjlt",
	"./tuv-raisin.svg": "3jpP",
	"./twitter.svg": "1cJS",
	"./vanguard_gs.png": "BJvX",
	"./webcam.png": "ifDv",
	"./welcomebonus-background.jpg": "myA6",
	"./weltsparen-business-logo.svg": "jMgP",
	"./weltsparen-logo.svg": "X7Po",
	"./weltsparen_logo.svg": "nfnU",
	"./xing.svg": "tZFo",
	"./youtube.svg": "rpS5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Yfmg";